import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { mediaUrl } from "../lib/api";
import { pkr } from "../lib/format";
import { useAuth } from "../context/AuthContext";

const buildText = (d, user) => {
  const desc = (d.description || "").replace(/\s+/g, " ").trim();
  return [
    d.brand_name ? `*${d.brand_name}*` : null,
    `*${d.name}*`,
    `Price: *${pkr(d.price)}* (fixed price)`,
    desc ? (desc.length > 220 ? desc.slice(0, 220) + "…" : desc) : null,
    d.delivery_info ? `Delivery: ${d.delivery_info}` : null,
    "",
    `For details & orders contact: ${user.name}${user.phone ? `, ${user.phone}` : ""}`,
    `Sales ID: ${user.sales_id} | Deal ref: ${d.ref}`,
  ].filter((x) => x !== null).join("\n");
};

export const ShareDealButton = ({ d, className = "", full = false }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const share = async () => {
    const text = buildText(d, user);
    const waUrl = `https://wa.me/?text=${encodeURIComponent(d.main_image ? `${text}\n\nPhoto: ${mediaUrl(d.main_image)}` : text)}`;
    const probe = typeof File !== "undefined" && new File([""], "x.jpg", { type: "image/jpeg" });
    const canFiles = d.main_image && navigator.canShare && probe && navigator.canShare({ files: [probe] });
    if (!canFiles) {
      window.open(waUrl, "_blank", "noopener");
      toast.info("Choose a customer chat in WhatsApp to send the deal");
      return;
    }
    setBusy(true);
    try {
      const blob = await fetch(mediaUrl(d.main_image)).then((r) => r.blob());
      const file = new File([blob], `${d.ref}.${(blob.type.split("/")[1] || "jpg").replace("jpeg", "jpg")}`, { type: blob.type || "image/jpeg" });
      await navigator.share({ files: [file], text });
    } catch (e) {
      // Gesture may be lost after the image download, so navigate in the same tab
      if (e?.name !== "AbortError") window.location.href = waUrl;
    }
    setBusy(false);
  };
  return (
    <Button type="button" variant="outline" onClick={share} disabled={busy} data-testid={`share-deal-${d.ref}`}
      aria-label="Share on WhatsApp" title="Share on WhatsApp"
      className={`border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800 ${className}`}>
      <MessageCircle className={full ? "mr-2 h-5 w-5" : "h-5 w-5"} />{full && "Share on WhatsApp"}
    </Button>
  );
};
